/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ComunicazioneOutboxStato } from './comunicazione-outbox-stato';
import { EventoTipoPratica } from './evento-tipo-pratica';
import { CanaleComunicazione } from './canale-comunicazione';


export interface ComunicazioneOutboxListFilter { 
    comune_id?: string;
    tipo_pratica_id?: string;
    codice_pratica?: string;
    canale?: CanaleComunicazione;
    evento?: EventoTipoPratica;
    stato?: ComunicazioneOutboxStato;
    da?: string;
    a?: string;
}



